<template>
  <section class="d-flex flex-column bg-clock w-100" :class="wrapperClass">
    <ul v-if="hasMilestones" class="nav list-group">
      <router-link
            v-for="milestone in milestones"
            :key="milestone.id"
            :to="`milestones/${milestone.slug}`"
            tag="li"
            class="list-group-item"
      >
        <h3>{{ milestone.title }}</h3>
        {{ relativeDate(milestone.date) }}
      </router-link>
    </ul>
    <div v-else class="text-center">
      <h3 class="align-self-center">No Milestones</h3>
      <router-link to="/new">Add one</router-link>
    </div>
  </section>
</template>

<script>
  import store from '../store/store'
  import relativeDate from '../utils/relativeDate'

  export default {
    methods: {
      relativeDate,
    },
    computed: {
      hasMilestones () {
        return store.state.milestones.length
      },
      milestones () {
        return store.state.milestones
      },
      wrapperClass () {
        return {
          'justify-content-center': !this.hasMilestones,
          'empty': !this.hasMilestones
        }
      }
    }
  }
</script>

